import React from "react";
import { Typography, Divider, Row, Col, Space, Form, Input, Checkbox, Button, F } from "antd";
import WebstoreItem from "../WebstoreItem";
export default function AdvancedSecion(props) {


    const { ws, form } = props;

    const default_ws_login_required_message = "Ordering from our site is available only to preauthorized customers.  Please contact us by phone at @@phone@@ or email at @@email@@ to have us create or authorize your account.";

    return (
        <>
            <div id="advanced" style={{ "padding": "10px 30px" }}>
                <Typography.Title level={4}>Advanced</Typography.Title>
                <Divider />

                {/* Custom Header text */}
                <div id="ws_head_custom_text"></div>
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>

                        {/* Private webstore */}
                        <div id="ws_self_login_required"></div>
                        <WebstoreItem
                            name="global:ws_self_login_required"
                            value={(ws["global:ws_self_login_required"]) ? true : false}
                            heading="Private webstore"
                            description={<div>When this box is checked, access to this site is only allowed by a site administrator or someone with the appropriate permissions. Some stores may set their site to Private when they are first customizing and configuring their Webstore until they are comfortable and ready to make it visible.</div>}
                        />
        
                        <Divider dashed />
                        {/* Treat non-approved customers as anonymous users */}
                        <div id="ws_use_whitelist"></div>
                        <WebstoreItem
                            name="global:ws_use_whitelist"
                            value={(ws["global:ws_use_whitelist"]) ? true : false}
                            heading="Treat non-approved customers as anonymous users"
                            description={<div>When this box is checked, customers whom you have not approved on the customer accounts page will be given the same level of access to this webtore as those who have not created an account or logged in. This will have no effect unless other options are selected that affect anonymous users, such as hiding the cart or prices.</div>}
                        />
        
                        <Divider dashed />
                        {/* Visible only when customer is logged in */}
                        <div id="ws_login_required"></div>
                        <WebstoreItem
                            name="global:ws_login_required"
                            value={(ws["global:ws_login_required"]) ? true : false}
                            heading="Visible only when customer is logged in"
                            description={<div>When this box is checked, access to this site is only granted to customers with accounts registered with Bookmanager. A "send invitation" option will appear in the webstore's menu bar to those with proper permissions. </div>}
                        />
        
                        <Divider dashed />
                        {/* Visible only when customer is logged in Message */}
                        <div id="ws_login_required_message"></div>
                        <Space>
                            <div style={{ "width": "35px" }}></div>
                            <div>
                                <Typography.Title level={5}>Login Prompt</Typography.Title>
                                <Typography.Paragraph type="secondary">This message will show up when the user is prompted to log in. You can customize it; your store’s email address and phone number will be automatically filled in for the @@phone@@ and @@email@@ placeholders. Leave it empty to use the default message.</Typography.Paragraph>
                                <Form.Item initialValue={(ws["global:ws_login_required_message"]) ? ws["global:ws_login_required_message"] : default_ws_login_required_message} name="global:ws_login_required_message" >
                                    <Input.TextArea showCount maxLength={300} style={{ "maxWidth": "500px" }} rows={4} >
                                    </Input.TextArea>
                                </Form.Item>
                                <div className="shim"></div> <div className="shim"></div>
                                <Button size="small" onClick={() => form.setFieldsValue({ ws_login_required_message: default_ws_login_required_message })} type="primary"><small>Use default</small></Button>
                            </div>
                        </Space>
        
                        <Divider dashed />
                        {/* Allow customers to view their lists at any Bookmanager site */}
                        <div id="ws_allow_list_transfer"></div>
                        <WebstoreItem
                            name="global:ws_allow_list_transfer"
                            value={(ws["global:ws_allow_list_transfer"]) ? true : false}
                            heading="Allow customers to view their lists at any Bookmanager site"
                            description={<div>When this box is unchecked, customers creating a list at your site will not see their list at another Bookmanager webstore, and likewise, lists they create at other stores will not be visible from your site. Tip: This feature is popular with librarians but booksellers might prefer to discourage shopping at other stores.</div>}
                        />
        
                        <Divider dashed />
                        {/* Enable automatic browse redirection*/}
                        <div id="ws_auto_browse_destination"></div>
                        <WebstoreItem
                            name="global:ws_auto_browse_destination"
                            value={(ws["global:ws_auto_browse_destination"]) ? true : false}
                            heading="Enable automatic browse redirection"
                            description={<div>When this box is checked, you (or other staff/users with the Store login) will be forwarded to the TitleBrowser after logging in.</div>}
                        />
        
                        <Divider dashed />
                        <div id="ws_homeurl"></div>
                        {/* Alternate home page URL */}
                        <Space>
                            <div style={{ "width": "35px" }}></div>
                            <div>
                                <Typography.Title level={5}>Alternate home page URL</Typography.Title>
                                <Typography.Paragraph type="secondary">If you want visitors to be taken to another site when they click Home, please enter in the address in the box. Otherwise, they will simply return to the main page of your Webstore.</Typography.Paragraph>
                                <Form.Item name="global:ws_homeurl" rules={[{ type: "url", message: "Must be a valid url." }]} initialValue={ws["global:ws_homeurl"]} >
                                    <Input style={{ "maxWidth": "500px" }} placeholder="https://example.com/" />
                                </Form.Item>
                            </div>
                        </Space>
        
                        <Divider dashed />
                        <div id="ws_landing"></div>
                        {/* Landing page URL*/}
                        <Space>
                            <div style={{ "width": "35px" }}></div>
                            <div>
                                <Typography.Title level={5}>Landing page URL</Typography.Title>
                                <Typography.Paragraph type="secondary">If you want visitors to be taken to another page when they initially navigate to your front page, enter the address in the box. Otherwise they will simply land on the front page of your Webstore.</Typography.Paragraph>
                                <Form.Item name="global:ws_landing" rules={[{ type: "url", message: "Must be a valid url." }]} initialValue={ws["global:ws_landing"]} >
                                    <Input style={{ "maxWidth": "500px" }} placeholder="https://example.com/" />
                                </Form.Item>
                                <div className="shim"></div><div className="shim"></div>
                                <Form.Item valuePropName='checked' initialValue={(ws["global:ws_landing_logged_out"]) ? true : false} name="global:ws_landing_logged_out" noStyle>
                                    <Checkbox>Only redirect users who are <strong>not</strong> logged in</Checkbox>
                                </Form.Item>
                            </div>
                        </Space>
        
                        <Divider dashed />

                        <Typography.Title level={5} >Custom head and body additions</Typography.Title>
                        <Typography.Paragraph type="secondary">These fields allow you to add JavaScript, CSS, etc. before the closing HTML "head" and "body" tags on your Webstore.<br /> Note: These settings apply to both mobile and desktop versions of the site.</Typography.Paragraph>
                        <Typography.Text><strong>Head:</strong></Typography.Text>
                        <div className="shim"></div>
                        <Form.Item name="global:ws_head_custom_text" initialValue={ws["global:ws_head_custom_text"]} noStyle >
                            <Input.TextArea maxLength={1000} showCount style={{ "maxWidth": "500px" }} rows={3} ></Input.TextArea>
                        </Form.Item>
                        <div className="shim"></div><div className="shim"></div><div className="shim"></div>
                        <Typography.Text><strong>Body:</strong></Typography.Text>
                        <div className="shim"></div>
                        <Form.Item name="global:ws_body_custom_text" initialValue={ws["global:ws_body_custom_text"]} noStyle >
                            <Input.TextArea maxLength={1000} showCount style={{ "maxWidth": "500px" }} rows={3} ></Input.TextArea>
                        </Form.Item>
                    </div>
                </Space>


            </div>
        </>
    )
}